"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('themeOption', {
    isQuickOptionExpanded: false,
});
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/data/store/store.js
// module id = 3731
// module chunks = 2